import React, { useState } from 'react';

interface FloatingLabelInputProps extends React.InputHTMLAttributes<HTMLInputElement> {
  label: string;
}

const FloatingLabelInput: React.FC<FloatingLabelInputProps> = ({ label, ...props }) => {
  const [isFocused, setIsFocused] = useState(false);
  const hasValue = props.value && String(props.value).length > 0;

  const labelClasses = `absolute left-3 transition-all duration-200 ease-in-out pointer-events-none 
    ${isFocused || hasValue ? 'top-1 text-xs text-blue-500 dark:text-blue-400' : 'top-1/2 -translate-y-1/2 text-gray-500 dark:text-gray-400'}`;

  return (
    <div className="relative">
      <input
        {...props}
        onFocus={() => setIsFocused(true)}
        onBlur={() => setIsFocused(false)}
        className="w-full px-3 pt-4 pb-2 text-black dark:text-white bg-white dark:bg-gray-800 border border-gray-300 dark:border-gray-700 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500 peer"
      />
      <label htmlFor={props.id} className={labelClasses}>
        {label}
      </label>
    </div>
  );
};

export default FloatingLabelInput;
